import gql from "graphql-tag";
import { BENEFICIARY_FRAGMENT } from "../beneficiary/fragment";

export const TRANSACTION_FRAGMENT = gql`
  fragment TransactionInfo on Transaction {
    amount
    billingType
    creationDate
    currency
    declineReason
    direction
    executionDate
    id
    isBilling
    linkcyId
    netAmount
    note
    noteLinkcy
    paymentType
    reference
    sequence
    status
    type
    receiver {
      ...BeneficiaryInfo
    }
    sender {
      ...BeneficiaryInfo
    }
  }
  ${BENEFICIARY_FRAGMENT}
`;

export const DEBTOR_CREDITOR_FRAGMENT = gql`
  fragment DebtorCreditor on DebtorCreditorInfo {
    accountPnvtId
    bankDigit
    bankName
    bic
    clientId
    iban
    id
    name
  }
`;

export const TRANSACTION_PNVT_FRAGMENT = gql`
  fragment TransactionPnvtInfo on TransactionPnvt {
    amount
    billingType
    category
    creationDate
    creditor {
      ...DebtorCreditor
    }
    currency
    debtor {
      ...DebtorCreditor
    }
    direction
    docPaynovateId
    executionDate
    id
    isBilling
    methodeId
    note
    notePnvt
    paynovateId
    purpose
    sepaTrxId
    sequence
    settlementDate
    signedAt
    status
    statusId
    statusReason
    statusReasonCode
    typeId
    userId
  }
  ${DEBTOR_CREDITOR_FRAGMENT}
`;

export const VOP_FRAGMENT = gql`
  fragment VoPInfo on VoP {
    best_matched_name
    match_result
    request_id
    timestamp
    verification_token
  }
`;
